import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import style from "../common.module.scss";
import CustomButton from "../../custom/custom-button/CustomButton";
import { useClickOutside } from "../../../hooks/useClickOutside";
import { t } from "i18next";

const PhotoViewer = ({
  user,
  setShowModal,
  imgUrl,
  onDownload,
  onClose,
  ShowBtnDownload = false,
}) => {
  const modalRef = useRef(null);

  useClickOutside(modalRef, () => {
    onClose();
  });

  return ReactDOM.createPortal(
    <div className="modal-overlay" data-portal-modal="true">
      <div
        ref={modalRef}
        style={{
          backgroundColor: "#ffffff",
          height: "600px",
          width: "750px",
          margin: "20px auto",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            padding: "14px 24px",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#ffffff",
            justifyContent: "space-between",
            borderBottom: "1px solid #eeeeee",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
          }}
        >
          <div style={{ fontSize: "16px", backgroundColor: "#ffffff" }}>
            <img style={{ objectFit: "cover" }} width="700px" height="500px" src={imgUrl} alt="" />
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}
        >
          {ShowBtnDownload && (
            <CustomButton style={{ width: "200px" }} text={t('balanceList.download')} onClick={onDownload} />
          )}
          <CustomButton
            style={{ width: "200px" }}
            text={t('confirmDocs.buttonClose')}
            onClick={() => {
              onClose();
            }}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PhotoViewer;
